import { render } from "./serviceDialog.vue?vue&type=template&id=dce93b8a&scoped=true"
import script from "./serviceDialog.vue?vue&type=script&lang=js"
export * from "./serviceDialog.vue?vue&type=script&lang=js"

import "./serviceDialog.vue?vue&type=style&index=0&id=dce93b8a&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce93b8a"]])

export default __exports__